import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Coimbatore() {
    const [openFaq, setOpenFaq] = useState(null);
    const navigate = useNavigate();

    const faqs = [
        {
            q: "How can I book a self drive car in Coimbatore with Wow carz?",
            a: "Booking is simple: visit the website or app, choose your car, select a package (hourly/daily/weekly or 100 km trip), and confirm. You'll receive a booking confirmation and pickup details.",
        },
        {
            q: "What documents are required to rent a car in Coimbatore?",
            a: "You need a valid driving license (minimum age 21 and at least 1 year of driving history) and a government-issued ID (Aadhar or Passport).",
        },
        {
            q: "Can I rent a car for a short trip within the city?",
            a: "Yes — Wow carz offers hourly, daily and monthly packages suitable for city travel, shopping, meetings, and short outings.",
        },
        {
            q: "Is it possible to take the rental car outside Coimbatore?",
            a: "Yes — choose the appropriate outstation package to drive to nearby destinations like Nandi Hills, Mysore, Coorg and more. Check package details for kilometer limits and charges.",
        },
        {
            q: "Why should I choose Wow carz over other car rental services in Coimbatore?",
            a: "Wow carz provides hassle-free booking, competitive pricing, well-maintained cars and 24/7 support — giving you freedom to travel at your own pace.",
        },
        {
            q: "Are Wow carz rentals available for both short and long durations?",
            a: "Yes — you can book hourly packages for short trips or daily/weekly rentals for long trips and weekend getaways.",
        },
    ];

    const places = [
        {
            image: "/assets/siruvani.jpg",
            title: "Siruvani Waterfalls",
            desc: "Located in the Western Ghats, Siruvani is famous for having one of the sweetest waters in the world and offers breathtaking natural beauty.",
        },
        {
            image: "/assets/valparai.jpg",
            title: "Valparai Hill Station",
            desc: "A scenic hill station about 100 km from Coimbatore known for tea estates, winding roads, wildlife sightings, and misty mountain views.",
        },
        {
            image: "/assets/coonor.jpg",
            title: "Coonoor Hill Station",
            desc: "A beautiful hill station near Coimbatore known for its lush tea plantations, cool climate, and scenic viewpoints like Dolphin’s Nose and Lamb’s Rock. It is a perfect destination for a peaceful hill drive and nature getaway.",
        },
        {
            image: "/assets/kovai-kutralam.jpg",
            title: "Kovai Kutralam Waterfalls",
            desc: "A beautiful waterfall inside the Siruvani forest range, offering a refreshing escape into nature and greenery.",
        },
        {
            image: "/assets/topslip.jpg",
            title: "Topslip (Anamalai Tiger Reserve)",
            desc: "A popular wildlife destination near Pollachi where visitors can experience forest safaris, elephant camps, and rich biodiversity.",
        },
        {
            image: "/assets/ooty.jpg",
            title: "Ooty (Udhagamandalam)",
            desc: "One of the most famous hill stations in South India located in the Nilgiri Hills, known for tea gardens, cool climate, and scenic landscapes.",
        },
    ];

    const nearplaces = [
        {
            image: "/assets/kotagiri.jpg",
            title: "Kotagiri Hill Station (68 km)",
            desc: "Kotagiri is a peaceful hill station near Coimbatore in the Nilgiri hills, known for its lush tea plantations, cool climate, and scenic viewpoints. It is a perfect destination for nature lovers and a refreshing road trip from Coimbatore.",
        },
        {
            image: "/assets/adiyogi.jpg",
            title: "Adiyogi Shiva Statue (30 km)",
            desc: "The 112-foot Adiyogi statue at Isha Yoga Center is the world's largest bust statue of Lord Shiva and a major spiritual and tourist attraction near Coimbatore.",
        },
        {
            image: "/assets/gassforestmuseum.jpg",
            title: "Gass Forest Museum (3 km)",
            desc: "One of India's oldest forest museums located near Coimbatore Forest College, showcasing wildlife specimens, timber collections, and forest heritage.",
        },
        {
            image: "/assets/palani.jpg",
            title: "Palani Murugan Temple (110 km)",
            desc: "Palani is one of the most famous pilgrimage destinations near Coimbatore, dedicated to Lord Murugan. Located on a hill in the Dindigul district, the temple attracts thousands of devotees and offers a scenic spiritual road trip from the city.",
        }, {
            image: "/assets/monkey.jpg",
            title: "Monkey Falls (30 km)",
            desc: "Monkey Falls is a beautiful natural waterfall located on the Pollachi–Valparai road near Coimbatore. Surrounded by lush forests of the Western Ghats, it is a popular spot for nature lovers and a refreshing stop during road trips.",
        },
    ];

    const whyCards = [
        {
            title: "Easy Booking in Coimbatore",
            text: "Book your self-drive car in Coimbatore within minutes and start your journey smoothly across the city or beyond.",
        },
        {
            title: "Safe & Well-Maintained Cars",
            text: "Our vehicles are regularly serviced and sanitized, ensuring a safe and comfortable drive around Coimbatore and Tamil Nadu.",
        },
        {
            title: "Flexible Rental Plans",
            text: "Choose hourly, daily, or outstation packages perfect for temple visits, business trips, or weekend getaways.",
        },
        {
            title: "Explore Coimbatore & Nearby Getaways",
            text: "Drive to Marudhamalai Temple, Adiyogi Shiva Statue, Siruvani Waterfalls, Valparai, or Ooty with complete freedom and comfort."
        },
        {
            title: "Airport & Railway Station Pickup",
            text: "Convenient car delivery at Coimbatore International Airport, Coimbatore Junction railway station, or your doorstep – anytime you need."
        }
    ];

    // Slider settings
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1, arrows: false },
            },
        ],
    };

    return (
        <div className="min-h-screen bg-gray-50 text-gray-800 font-inter">
            {/* Header */}
            <header className="bg-orange-100 shadow-sm sticky top-0 z-20">
                <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between">
                    <div className="flex-shrink-0">
                        <img
                            onClick={() => navigate("/")}
                            loading="lazy"
                            style={{ height: 55, width: 160 }}
                            src="https://bagzpack.s3.amazonaws.com/logo/68ea80da-f61b-4333-a4ed-ebae07c63893/IMG/1645694302682.png"
                            alt="wowcarzlogo"
                            className="object-cover cursor-pointer"
                        />
                    </div>

                    <div className="flex items-center gap-3">
                        <a
                            href="/"
                            className="bg-orange-600 text-white px-4 py-2 rounded-lg shadow hover:bg-orange-700 transition"
                        >
                            Book Now
                        </a>
                        <a
                            href="tel:+919844300066"
                            className="inline-flex items-center gap-2 border border-gray-200 px-3 py-2 rounded-lg text-sm hover:bg-gray-100 transition"
                        >
                            📞 Call Us
                        </a>
                    </div>
                </div>
            </header>

            <main className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                {/* Hero */}
                <section className="relative rounded-2xl h-[500px] sm:h-[550px] lg:h-[600px] overflow-hidden">

                    <img
                        src="/assets/coim.jpg"
                        alt="Self Drive Cars Chennai"
                        className="absolute inset-0 w-full h-full object-contain scale-110"
                    />
                    <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-center px-6 sm:px-12 ">
                        <h2 className="text-3xl sm:text-5xl font-bold text-white mb-4 animate-fade-in">
                            Self Drive Cars in Coimbatore
                        </h2>

                        <p className="text-gray-200 text-base sm:text-lg mb-6 max-w-xl leading-relaxed">
                            Explore Coimbatore and nearby destinations with hassle-free self drive
                            cars from Wow Carz.
                        </p>
                    </div>

                </section>


                {/* Explore Section */}
                <section className="bg-orange-200 p-5 m-5">
                    <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-3xl p-8 sm:p-12 text-center">
                        <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6">
                            Explore Coimbatore with Wow Carz
                        </h2>
                        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                            Explore Coimbatore with the comfort and freedom of a self drive car rental designed for modern travelers. Wow Carz offers reliable and premium self drive cars in Coimbatore, making it easy to travel across the city or plan a relaxing getaway whenever you want.

                            Perfect for business travel, family outings, weekend road trips, and short trips within 100 km, Wow Carz provides flexible self drive car rental in Coimbatore without the hassle of fixed schedules or driver dependency. Simply pick your car, start your journey, and enjoy complete travel freedom.

                            Choose Wow Carz for affordable, safe, and convenient self drive car rentals in Coimbatore and experience the joy of exploring the city and nearby destinations at your own pace.
                        </p>
                    </div>
                </section>

                {/* Why Rent Section (Slider) */}
                <section className="py-12 bg-gray-50">
                    <h2 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-gray-900">
                        Why Rent With Wow Carz?
                    </h2>
                    <Slider {...sliderSettings} className="px-6 [&_.slick-dots]:left-0">
                        {whyCards.map((card, i) => (
                            <div key={i} className="px-3">
                                <div className="bg-white rounded-2xl shadow-lg p-6 text-center hover:shadow-xl transition">
                                    <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
                                    <p className="text-gray-600 text-sm">{card.text}</p>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </section>

                {/* Plan Your Trip */}
                <section className="py-12 sm:py-16 bg-orange-300 mx-4 sm:mx-8 lg:mx-16 rounded-2xl">
                    <div className="max-w-7xl mx-auto text-center px-4">

                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-10 text-gray-900">
                            Plan Your Trip to Coimbatore
                        </h2>

                        <Slider {...sliderSettings} className="px-2">

                            {/* Card 1 */}
                            <div className="px-3">
                                <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 text-2xl">
                                        🏛️
                                    </div>

                                    <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                        Interesting Facts About Coimbatore
                                    </h3>

                                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                        Coimbatore, often called the “Manchester of South India,” is one of Tamil Nadu’s fastest-growing cities known for its textile industry, pleasant climate, and vibrant culture.
                                    </p>
                                </div>
                            </div>

                            {/* Card 2 */}
                            <div className="px-3">
                                <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 text-2xl">
                                        🎓
                                    </div>

                                    <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                        Engineering Education Hub
                                    </h3>

                                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                        Coimbatore is widely known as a leading education hub with reputed engineering institutions like PSG College of Technology, Coimbatore Institute of Technology.
                                    </p>
                                </div>
                            </div>

                            {/* Card 3 */}
                            <div className="px-3">
                                <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-red-100 text-red-600 text-2xl">
                                        🎉
                                    </div>

                                    <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                        Famous Festivals in Coimbatore
                                    </h3>

                                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                        Major festivals include Pongal, Navaratri, and Maha Shivaratri at the Adiyogi and Isha Yoga Center. Temple festivals at Marudhamalai also attract many devotees.
                                    </p>
                                </div>
                            </div>

                            {/* Card 4 */}
                            <div className="px-3">
                                <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition duration-300">
                                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-yellow-100 text-yellow-600 text-2xl">
                                        🌤️
                                    </div>

                                    <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                        Best Time to Visit Coimbatore
                                    </h3>

                                    <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                        The best time to visit Coimbatore is from September to March when the weather is pleasant for sightseeing and road trips to Ooty, Valparai, and Siruvani.
                                    </p>
                                </div>
                            </div>

                        </Slider>
                    </div>
                </section>




                {/* Near Places Section (Slider) */}
                <section className="mt-12">
                    <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
                        Places Near by Coimbatore
                    </h3>
                    <p className="text-gray-600 mb-6 text-center">
                        Perfect for day trips and weekend getaways with your Wow Carz ride.
                    </p>
                    <Slider {...sliderSettings} className="px-6 [&_.slick-dots]:left-0">
                        {nearplaces.map((place) => (
                            <div key={nearplaces.title} className="px-3">
                                <article className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 text-center transition">
                                    <img
                                        className="w-48 h-48 object-cover rounded-xl mx-auto mb-4"
                                        src={place.image}
                                        alt={place.title}
                                    />
                                    <h4 className="font-semibold text-lg mb-2">{place.title}</h4>
                                    <p className="text-gray-600 text-sm leading-relaxed">
                                        {place.desc}
                                    </p>
                                </article>
                            </div>
                        ))}
                    </Slider>
                </section>




                {/* Top Places */}
                <section className="mt-16">
                    <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
                        Top Places to Visit in and Around Coimbatore
                    </h3>
                    <p className="text-gray-600 mb-6 text-center">
                        Explore iconic landmarks, serene gardens, and historic towns with
                        your Wow Carz ride.
                    </p>
                    {/* Top place(PC view)*/}
                    <div className="hidden lg:grid grid-cols-3 gap-8 px-4 max-w-6xl mx-auto">
                        {places.map((place) => (
                            <div
                                key={place.title}
                                className="bg-white rounded-xl shadow-md hover:shadow-xl transition p-6 text-center"
                            >
                                <img
                                    src={place.image}
                                    alt={place.title}
                                    className="w-full h-56 object-cover rounded-lg mb-4"
                                />

                                <h4 className="text-xl font-semibold text-gray-900 mb-2">
                                    {place.title}
                                </h4>

                                <p className="text-gray-600 text-sm">
                                    {place.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                    {/* Top place(Mobile view)*/}
                    <div className="block lg:hidden max-w-xl mx-auto">
                        <Slider {...sliderSettings}>
                            {places.map((place) => (
                                <div key={place.title} className="px-3">
                                    <div className="bg-white rounded-xl shadow-md p-6 text-center">

                                        <img
                                            src={place.image}
                                            alt={place.title}
                                            className="w-full h-52 object-cover rounded-lg mb-4"
                                        />

                                        <h4 className="text-lg font-semibold text-gray-900 mb-2">
                                            {place.title}
                                        </h4>

                                        <p className="text-gray-600 text-sm">
                                            {place.desc}
                                        </p>

                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                </section>




                {/* FAQ */}
                <section className="mt-16">
                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 text-center">
                        Frequently Asked Questions
                    </h3>
                    <div className="space-y-4">
                        {faqs.map((f, i) => (
                            <div
                                key={i}
                                className="border rounded-xl bg-white shadow-sm overflow-hidden"
                            >
                                <button
                                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                                    className="w-full text-left px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition"
                                >
                                    <span className="font-medium text-gray-800">{f.q}</span>
                                    <span className="text-gray-500 text-lg">
                                        {openFaq === i ? "−" : "+"}
                                    </span>
                                </button>
                                <div
                                    className={`px-5 overflow-hidden transition-all duration-300 ${openFaq === i ? "max-h-40 py-3" : "max-h-0"
                                        }`}
                                >
                                    <p className="text-gray-700 text-sm leading-relaxed">{f.a}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* CTA */}
                <section className="mt-16 bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600 text-white p-8 rounded-3xl flex flex-col sm:flex-row items-center justify-between gap-6">
                    <div className="text-center sm:text-left">
                        <h4 className="text-2xl font-semibold">
                            Ready to Start Your Journey?
                        </h4>
                        <p className="text-sm mt-2 text-blue-100">
                            Experience hassle-free driving with Wow Carz today.
                        </p>
                    </div>
                    <div className="flex gap-3">
                        <a
                            href="/"
                            className="bg-white text-blue-600 px-6 py-3 rounded-lg font-medium hover:bg-blue-100 transition"
                        >
                            Book Now
                        </a>
                        <a
                            href="tel:+919844300066"
                            className="border border-white px-6 py-3 rounded-lg hover:bg-white hover:text-blue-600 transition"
                        >
                            Call Us
                        </a>
                    </div>
                </section>

                {/* Footer */}
                <footer className="mt-10 text-center text-sm text-gray-500">
                    © {new Date().getFullYear()} Wow Carz — All rights reserved
                </footer>
            </main>
        </div>
    );
}

export default Coimbatore;
